import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Input, message, Modal } from 'antd';
import { deprovisionSystem } from '~lib/netconnClient';
import handleAuthErr from '~util/handleAuthErr';
import logger from '~util/logger';
import constants from '~util/constants';

const DeprovisionModal = ({ nai, closeModal, confirmClick, isVisible }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [inputConfirm, setInputConfirm] = useState('');

  const handleDeprovisionClick = () => {
    setIsLoading(true);

    deprovisionSystem(nai)
      .then(resp => {
        if (resp) {
          confirmClick(resp);
        }
        setIsLoading(false);
      })
      .catch(
        handleAuthErr(err => {
          logger.err(err);
          message.error(constants.API_ERR_MESSAGE);
        })
      )
      .finally(() => closeModal());
  };

  const disabledSubmit = inputConfirm !== nai;

  return (
    <Modal
      visible={isVisible}
      confirmLoading={isLoading}
      onCancel={closeModal}
      centered
      title="Are you absolutely sure?"
      okText="Confirm Deprovision"
      footer={[
        <Button key="back" type="primary" onClick={closeModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="danger"
          loading={isLoading}
          disabled={disabledSubmit}
          onClick={handleDeprovisionClick}
          data-testid={`confirm-button-${disabledSubmit ? 'disabled' : 'enabled'}`}
        >
          I understand the risk & Deprovision this NAI.
        </Button>,
      ]}
    >
      <p>
        This action cannot be undone. This will permanently delete the {nai} registration from the
        network operating systems. Please type <strong>{nai}</strong> to confirm.
      </p>
      <Input
        placeholder="type NAI here"
        onChange={e => setInputConfirm(e.target.value)}
        value={inputConfirm}
      />
    </Modal>
  );
};

DeprovisionModal.propTypes = {
  nai: PropTypes.string.isRequired,
  closeModal: PropTypes.func.isRequired,
  confirmClick: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
};

DeprovisionModal.displayName = 'DeprovisionModal';

export { DeprovisionModal };
